function getBrandSymbolFromId(id) {
    switch(id) {
        case 1: 
            return 'MSQ';
        case 11:
            return 'HWC';
    }
}

export default getBrandSymbolFromId;